import { ApproveBullpensStore } from "stores/ApproveBullpensStore";
import { Bullpen } from "./Bullpen";

export class WaitingForApprovalBullpen extends Bullpen {
  static _store: ApproveBullpensStore;
}
